import styled from '@emotion/styled';

const PreviewContainer = styled.div`
  position: relative;
`;

const Preview = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 14%);
  padding-bottom 56.25%;
  position: relative;
  display: inline-block;
  padding-bottom: 62.5%;
  width: 100%;
`;

const ViewToggle = styled.a`
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: inline-block;
  font-size: 0.75em;
  padding: 0.833em;
  position: absolute;
  right: 0;
  text-decoration: none;
  top: 0;
  transition: all 0.15s ease-in-out;
  whitespace: nowrap;
  z-index: 1;

  &:hover {
    background-color: #000000;
    color: #ffffff;
  }
`;

const ShinglePreview = ({ onToggle, selectedView, shingleColor }) => {
  const previewBackgroundImageUrl =
    selectedView === 'shingle' ? shingleColor.swatch_768x485_url : shingleColor.house_1229x768_url2;

  const toggle = () => {
    onToggle(selectedView === 'shingle' ? 'house' : 'shingle');
  };

  return (
    <PreviewContainer>
      <Preview
        className="img-responsive"
        key={shingleColor.uid}
        style={{ backgroundImage: `url(${previewBackgroundImageUrl})` }}
      />
      <ViewToggle onClick={() => toggle()}>{selectedView === 'shingle' ? 'House' : 'Shingle'} View</ViewToggle>
    </PreviewContainer>
  );
};

export default ShinglePreview;
